// mutations
const RESTAURANT_PRODUCTS_SUBCATEGORIES_ALL = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES_FORM = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES_SHOW = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES_CREATE = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
    alert(restaurantProductsSubCategories.message)
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES_UPDATE = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
    alert(restaurantProductsSubCategories.message)
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES_DELETE = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
    alert(restaurantProductsSubCategories.message)
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_SUBCATEGORIES = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
    // alert(restaurantProductsSubCategories.message)
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_FILTER_SUBCATEGORIES = (state, restaurantProductsSubCategories) => {
  if (restaurantProductsSubCategories.code === 1) {
    state.restaurantProductsSubCategories = restaurantProductsSubCategories.data
    state.status = 'success'
    // alert(restaurantProductsSubCategories.message)
  } else {
    alert(restaurantProductsSubCategories.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_PRODUCTS_SUBCATEGORIES_ALL,
  RESTAURANT_PRODUCTS_SUBCATEGORIES_FORM,
  RESTAURANT_PRODUCTS_SUBCATEGORIES_SHOW,
  RESTAURANT_PRODUCTS_SUBCATEGORIES_CREATE,
  RESTAURANT_PRODUCTS_SUBCATEGORIES_UPDATE,
  RESTAURANT_PRODUCTS_SUBCATEGORIES_DELETE,
  RESTAURANT_PRODUCTS_SUBCATEGORIES,
  RESTAURANT_PRODUCTS_FILTER_SUBCATEGORIES
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/subcategories/mutations.js